import { createActions } from "../../utils/reduxsauce";

const { Types, Creators } = createActions(
  {
    getSku: { args: ["payload"], meta: { async: true } },
    getAllSkus: { args: ["payload"], meta: { async: true } },
    createSku: { args: ["payload"], meta: { async: true } },
    editSku: { args: ["payload"], meta: { async: true } },
    deleteSku: { args: ["payload"], meta: { async: true } },
    showDialog: { args: [], meta: { async: false } },
    showDeleteDialog: { args: [], meta: { async: false } },
    resetDialog: { args: [], meta: { async: false } },
  },
  {
    prefix: "@app/Skus/",
  },
);
export const ActionTypes = Types;
export default Creators;
